import React, { useCallback, useEffect, useRef, useState } from 'react'
import Wrapper, { CanvasContainer } from './styles'
import { isMobile, randomBetweenInterval } from 'shared/helpers';
import { useDispatch } from 'react-redux';
import { Canvas } from './styles';
import * as d3 from 'd3';
import Tooltip from 'components/Tooltip';

const Viz = ({data}) => {
  const [tooltipData, setTooltipData] = useState({});
  const [tooltipPosition, setTooltipPosition] = useState([0, 0]);
  const [tooltipShow, setTooltipShow] = useState(false);
  const canvas = useRef();
  const dispatch = useDispatch();


  useEffect(() => {
    const width = canvas.current.clientWidth;
    const height = canvas.current.clientHeight;
    const mult = isMobile() ? 0.2 : 0.45;
    const circleRadius = height * mult;
    const svg = d3.select(canvas.current)
                  .attr('width', width)
                  .attr('height', height);
    svg.selectAll('*').remove();

    const filter = svg.append("defs")
                      .append("filter")
                      .attr("id", "blur")
                      .append("feGaussianBlur")
                      .attr("stdDeviation", 2);
     

    const g = svg.append('g').attr('class', 'mainGroup');

    const zoomed = ({transform}) => {
      console.log('transform', transform);
    } 

    const zoom = d3.zoom()
    .scaleExtent([-1, 8])
    .on('zoom', function() {
        g.attr('transform', d3.event.transform);
    });

    svg.call(zoom);

    
    

    const nodes = g.selectAll('.node')
                   .data(data)
                   .enter()
                   .append('circle')
                   .attr('id', (d) => {
                    return `circle-${d.ID}`;
                   })
                   .attr('r', (d) => {
                     const r = isMobile() ? randomBetweenInterval(0.5, 7) : randomBetweenInterval(1, 15);
                     d.radius = r;
                     return r;
                   })
                   .attr('cx', (d) => {
                    const angle = d.ID % 360;
                    d.angle = angle;
                    const _c = width / 1.88 +  randomBetweenInterval(0, circleRadius) *  Math.cos(angle);
                    const c = _c;

                    d.cx = c;
                    return c;
                   })
                   .attr('cy', (d) => {
                    const _c = height / 2 +  circleRadius  *  Math.sin(d.angle);
                    const c = _c;
                    d.cy = c;
                    return c;
                   })
                   .attr('opacity', (d) => {
                    const o = randomBetweenInterval(0.2, 0.9);
                    d.originalOpacity = o;
                    return o;
                   })
                   .attr('fill', (d) => {
                    if(d.type === "Semblanza"){
                      return "#F7B47F"
                    }
                    if(d.type === "Perfil"){
                      return "#C5F4FF";
                    }
                    return '#F8F4E0';
                   })
                   .on('mouseover', (node) => {
                     node.stop = true;
                    document.body.style.cursor = "pointer";
                    const n = d3.select(`#circle-${node.ID}`);
                    n.attr('filter', 'url(#blur)');
                    n.attr('fill', '#F75E7F')
                    n.attr('opacity', 1);

                    const x = d3.event.pageX;
                    const y = d3.event.pageY;

                    setTooltipPosition([x, y]);
                    setTooltipData(node);
                    setTooltipShow(true);
                  })
                  .on('mouseleave', (node) => {
                    node.stop = false;
                    document.body.style.cursor = "default";
                    const n = d3.select(`#circle-${node.ID}`);
                    n.attr('filter', '')
                    n.attr('fill', (d) => {
                      if(d.type === "Semblanza"){
                        return "#F7B47F"
                      }
                      if(d.type === "Perfil"){
                        return "#C5F4FF";
                      }
                     return '#F8F4E0';
                    })
                    n.attr('opacity', node.originalOpacity)
                  
                    setTooltipShow(false);
                  })
                  .on('click', (d) => {
                    if(d.url && d.url !== 'Ninguno' && !isMobile()){
                      window.open(d.url);
                    }
                  })
    
    const tick = () => {
      try{
        requestAnimationFrame(tick);
        nodes.each((node) => {
          const n = d3.select(`#circle-${node.ID}`);
          if(node.stop){
            return;
          }

          if(!n && !node){
            return;
          }

          const cx = +n.attr('cx');
          const cy = +n.attr('cy');

          let rx = node.rx;

          if(!rx){
            rx = randomBetweenInterval(-0.085, 0.085) * Math.sin(randomBetweenInterval(-1, 1));
            node.rx = rx;
          }




          let ncx = cx + rx;
          if(ncx > width - node.radius || node.reverse){
            ncx = cx - rx;
            node.reverse = true;
          }

          if(node.reverse && ncx < (node.radius * 2)){
            ncx = cx + rx;
            node.reverse = false;
          }


          let ncy = cy + rx;

          if(ncy > height - node.radius || node.reverseY){
            ncy = cy - rx;
            node.reverseY = true;
          }

          if(node.reverseY && ncy < (node.radius * 2)){
            ncy = cy + rx;
            node.reverseY = false;
          }



          n.attr('cx', ncx);
          n.attr('cy', ncy);
        })
      }catch{
      }
      

    }

    if(!isMobile()){
      tick();
    }


  }, [data]);

  return(
    <Wrapper>
      <CanvasContainer id="canvasContainer">  
        <Canvas id="canvas" ref={canvas} />
        {tooltipShow && <Tooltip position={tooltipPosition} data={tooltipData}/>}
      </CanvasContainer>  
    </Wrapper>
  )
}

export default Viz;